"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIVACY_REQUIRED = void 0;
exports.systemPrivacy = systemPrivacy;
exports.observePrivacyRequired = observePrivacyRequired;
exports.personPrivacyStatus = personPrivacyStatus;
const ToolsFetch_1 = __importDefault(require("../React/Tools/ToolsFetch"));
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
exports.PRIVACY_REQUIRED = "ps-privacy-required";
async function systemPrivacy(ack) {
    const response = await fetch(`${MainSetupReact_1.default.serverUrl}v2/privacy/system${ack ? "/acknowledgements" : ""}`, {
        credentials: "include", method: ack ? "POST" : "GET",
        headers: { "Content-Type": "application/json" },
        ...(ack ? { body: JSON.stringify({ version: ack.version, revision: ack.revision, acknowledged: true }) } : {}),
    });
    if (!response.ok)
        throw Object.assign(new Error("Nie udało się pobrać lub zapisać informacji. Spróbuj ponownie."), { status: response.status });
    return response.json();
}
// Observe all interactive fetch callers, including legacy code not using ToolsFetch.
function observePrivacyRequired(onRequired) {
    const original = window.fetch;
    const observed = async (...args) => {
        const response = await original(...args);
        const url = String(args[0] instanceof Request ? args[0].url : args[0]);
        if (response.status === 428 && url.startsWith(MainSetupReact_1.default.serverUrl) && !url.includes("/public/"))
            onRequired();
        return response;
    };
    window.fetch = observed;
    return () => { if (window.fetch === observed)
        window.fetch = original; };
}
function personPrivacyStatus(personId) {
    return ToolsFetch_1.default.fetchJsonWithSafeError(MainSetupReact_1.default.serverUrl + 'admin/staffMember/' + personId + '/privacy', { credentials: 'include', cache: 'no-store' });
}
